module.exports = __webpack_public_path__ + "img/jiran_logo.2e113e5.svg";